import {
    createUnorderedVerticalList,
    IUnorderedVerticalListItem,
    IUnorderedVerticalListProperties,
} from '@vfde-brix/unordered-vertical-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { getSubscriptionBenefits } from '../helper/additionalPageOptionsHelper';
import { Id, TariffBenefitData } from '../interface/AdditionalPageOptions';
import { HtmlId } from '../container/App/enum';

const icon = 'checkmark-green';

const getVerticalListItem = (item: TariffBenefitData): IUnorderedVerticalListItem => ({
    business: NO_PATTERN_BUSINESS_LOGIC,
    headLine: item.text,
    tooltip: item.tooltip ? {
        business: NO_PATTERN_BUSINESS_LOGIC,
        stdHeadline: item.tooltip.headline,
        txtContent: item.tooltip.text,
    } : undefined,
    icon,
});

const updateTariffBenefits = (subId?: Id) => {
    if (!subId) {
        return null;
    }

    const containerEl = document.getElementById(HtmlId.TARIFF_BENEFITS);
    const benefits = getSubscriptionBenefits(subId);
    const props: IUnorderedVerticalListProperties<IUnorderedVerticalListItem> = {
        items: benefits.map(getVerticalListItem),
        business: NO_PATTERN_BUSINESS_LOGIC,
    };

    return containerEl && createUnorderedVerticalList(containerEl, props);
};

export default updateTariffBenefits;
